<thevatra-info-popup-wrapper class="confirmation-popup">
  <span info-popup-title
        class="confirmation-popup__title"
  >
    {{ data.message }}
  </span>
  <div class="confirmation-popup__actions"
       info-popup-actions
  >
    <button (click)="confirm()">
      {{ data.confirmLabel }}
    </button>
    <button (click)="closePopup()">
      {{ data.cancelLabel || 'Cancel' }}
    </button>
    <span class="confirmation-popup__close">
      <stusan-icon icon="close"
                   style="width: 30px; height: 30px; fill: rgb(255,255,255);"
                   (click)="closePopup(true)"
      ></stusan-icon>
    </span>
  </div>
</thevatra-info-popup-wrapper>
